import React, { useEffect } from 'react';
import Waiting from '../components/waiting';
import { querystring } from '../utils/helpers';
import { useStores } from '../hooks/use-stores';
import { useNavigate, useParams } from 'react-router-dom';

function TokenSignIn() {
    const { authStore } = useStores();
    const { token } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        authStore.setToken(token);
        let redirect = querystring('redirect') || '/';
        if (!redirect.startsWith('/')) redirect = `/${redirect}`;
        navigate(redirect);
    }, []);

    return <Waiting waitingActive={true} fullScreen={true} />;
}

export default TokenSignIn;
